import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { adminService } from '../../../../core/services'
import * as interfaces from '../../../../static/interfaces'
import * as Hooks from '../../../../utils/hooks'
import { Button } from '../../../atoms'
import AdminLayoutIndex from '../_layouts'
import { Container, Draggable } from 'react-smooth-dnd'
import arrayMove from 'array-move'
import * as constants from '../../../../static/constants'
import SvgIcon from 'components/atoms/SvgIcon'

declare var window: interfaces.IWindow

interface IProps {
  categories: {
    categories: IJsonResponse
  }
}

const AdminCategoryIndex: React.FC<IProps> = props => {
  Hooks.SetDocumentTitle('Admin category')
  const { data, pagination } = adminService.getDataFromJson(props.categories.categories)
  const [categories, setCategories] = React.useState(data)

  const onDrop = ({ removedIndex, addedIndex }) => {
    setCategories(old => arrayMove(old, removedIndex, addedIndex))
  }

  const onSubmit = () => {
    updateCategoriesOrder()
  }

  const updateCategoriesOrder = React.useCallback(async () => {
    const categories_ids = categories.map(item => {
      return item.id
    })
    const { updatedCategories, flush } = await adminService.updateCategories(categories_ids)
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    location.href = '/admin/categories'
  }, [categories])

  const handleDelete = React.useCallback(
    async id => {
      const { flush } = await adminService.deleteCategory(id)
      // TODO 成功レスポンスと揃えたい
      window.flashMessages.addMessage({
        text: flush.message,
        type: flush.type,
      })
      setCategories(categories.filter(category => category.id !== id))
    },
    [categories]
  )

  const handleClickDelete = id => {
    if (window.confirm(I18n.t('generic.delete_confirmation'))) {
      handleDelete(id)
    }
  }

  return (
    <AdminLayoutIndex
      model="category"
      title={
        <Heading>
          <span>{I18n.t('generic.categories')}</span>
          <Button small={true}>
            <a href="/admin/categories/new">{I18n.t('generic.create_new')}</a>
          </Button>
        </Heading>
      }
      main={
        <DraggableTable>
          <div className="Table">
            <div>
              <div className="Table_Row">
                <div className="Table_Header">{I18n.t('generic.id')}</div>
                <div className="Table_Header label">{I18n.t('generic.name')}</div>
                <div className="Table_Header label">{I18n.t('generic.name_ja')}</div>
                <div className="Table_Header label" />
                <div className="Table_Header handle" />
              </div>
            </div>
            <div>
              <Container onDrop={onDrop}>
                {categories.map((category, index) => {
                  return (
                    <Draggable key={`category-${index}`}>
                      <div className="Table_Row">
                        <div className="Table_Data">{category.id}</div>
                        <div className="Table_Data label">{category.name}</div>
                        <div className="Table_Data label">{category.name_ja}</div>
                        <div className="Table_Data">
                          <Button small={true}>
                            <a href={`/admin/categories/${category.id}/edit`}>
                              {I18n.t('generic.edit')}
                            </a>
                          </Button>
                          <Button
                            small={true}
                            handleClick={() => {
                              handleClickDelete(category.id)
                            }}
                          >
                            {I18n.t('generic.delete')}
                          </Button>
                        </div>
                        <div className="Table_Data handle">
                          <SvgIcon
                            name="drag_handle"
                            className="icon"
                            ariaHidden={true}
                            role="presentation"
                          />
                        </div>
                      </div>
                    </Draggable>
                  )
                })}
              </Container>
            </div>
          </div>
          <Button handleClick={onSubmit}>{I18n.t('generic.update_order')}</Button>
        </DraggableTable>
      }
    />
  )
}

const Heading = styled.div`
  .Button {
    margin-left: 12px;
  }
`

const DraggableTable = styled.div`
  .Table {
    display: table;
    margin-bottom: 20px;
    .Table_Header,
    .Table_Data {
      display: table-cell;
      max-width: 240px;
      width: 120px;
      height: 40px;
      padding: 4px 8px;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      border-bottom: solid 1px ${constants.COLORS.divider};
      &.handle {
        cursor: grab;
        &:active {
          cursor: grabbing;
        }
      }
      > a {
        color: ${constants.COLORS.primary};
      }
      &.label {
        width: 240px;
      }
      &.handle {
        width: 40px;
        text-align: center;
      }
    }
  }
`
export default AdminCategoryIndex
